export enum GetStartedSteps {
  PERSONAL_INFORMATION = "personal_information",
  VERIFY_BUSINESS = "verify_business",
  PREVIEW_BUSINESS = "preview_business",
}

export type TGetStartedFormData = {
  // Personal Information
  firstname: string;
  lastname: string;
  phoneNumber: string;
  countryCode: string;
  phoneNoCountryDialCode?: string;
  email: string;

  // Business Verification
  customerSubType: number;
  businessRegistrationNumber: string;
  businessName: string;
  businessAddress?: string;
  userPosition: number;
  password: string;
};
